module.exports = __webpack_public_path__ + "static/img/3.57f8fb0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/articles/4/3.jpg
// module id = 5HjG
// module chunks = 0